import { t } from 'i18next'

export const CONTACT_TITLE = t('contact.title')
export const CONTACT_FORM_TITLE = t('contact.form.title')

export const CONTACT_SUPPORT_EMAIL = t('contact.placeholder.email')
